import React from 'react';
import PropTypes from 'prop-types';

import IconWithText from 'components/Widgets/IconWithText';

export default function TrainingStatus({ affiliateTraining }) {
  const statusBackground = affiliateTraining.status === 'Completed' ? 'bg-primary' : 'bg-secondary';

  const dateFormat = (value) => {
    const date = new Date(value);
    const options = { dateStyle: 'long', timeStyle: 'short' };

    return new Intl.DateTimeFormat('en-US', options).format(date);
  };

  if (!affiliateTraining.status) {
    return null;
  }

  return (
    <IconWithText
      iconClassName={`dot-icon ${statusBackground}`}
      iconStyle={{ minWidth: '.8rem', minHeight: '.8rem' }}
      contentClassName="small fw-light text-gray-800"
      wrapperClassName="mt-1"
    >
      {affiliateTraining.status}
      {affiliateTraining.status === 'Completed' && (
      <>
        {' '}
        &bull;
        {' '}
        {dateFormat(affiliateTraining.completed_at)}
      </>
      )}
    </IconWithText>
  );
}

TrainingStatus.propTypes = {
  affiliateTraining: PropTypes.object.isRequired,
};
